<div class="table-responsive mt-3" [formGroup]="ownerForm" [attr.data-document-mode]="mode" [attr.data-sale-kind]="saleKind">
                  <div *ngIf="catalogueError" class="alert alert-danger m-2" role="alert">{{ catalogueError }}</div>
                  <div *ngIf="!locationId && !isReadOnly" class="alert alert-warning m-2" role="alert">Choose a stock location or warehouse before adding product lines.</div>
                  <fieldset class="p-0 m-0 border-0" [disabled]="!locationId && !isReadOnly" [attr.aria-label]="!locationId && !isReadOnly ? 'Choose a stock location to edit product lines' : 'Product lines'">
                  <table class="table table-vcenter table-editable mb-0" [class.product-lines-disabled]="!locationId && !isReadOnly"
                    [attr.aria-disabled]="!locationId && !isReadOnly">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Product</th>
                        <th *ngIf="itemColumnVisible">Individual Item</th>
                        <th>Variant</th>
                        <th *ngIf="showDescription">Description</th>
                        <th>Quantity</th>
                        <th *ngIf="showScheduledDate">Scheduled Date</th>
                        <th *ngIf="showUom">Unit</th>
                        <th>Unit Price</th>
                        <th *ngIf="showDeposit">Refundable Deposit</th>
                        <th *ngIf="showDiscount">Disc. %</th>
                        <th *ngIf="showTaxes">Taxes</th>
                        <th *ngIf="showAccount">Account</th>
                        <th *ngIf="analyticColumnVisible">Analytic Distribution</th>
                        <th class="text-end">{{ showTaxes ? 'Tax' : '' }}</th>
                        <th class="text-end">Total</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody formArrayName="lines" cdkDropList [cdkDropListData]="lineGroups"
                      (cdkDropListDropped)="reorderLine.emit($event)">
                      <tr *ngFor="let line of lineGroups; let index = index" [formGroupName]="index" cdkDrag
                        [cdkDragDisabled]="isReadOnly" [class.table-danger]="!!line.getError('stockAvailability')" [class.document-section-line]="lineType(line) === 'section'"
                        [class.document-note-line]="lineType(line) === 'note'">
                        <td><button *ngIf="!isReadOnly" class="btn btn-sm btn-icon drag-handle line-mutation-action"
                            type="button" cdkDragHandle aria-label="Reorder line">⋮⋮</button></td>
                        <ng-container *ngIf="lineType(line) === 'product'; else textLine">
                          <td>
                            <app-autocomplete-select formControlName="product_id" placeholder="Choose products"
                              [options]="productOptions" [searchFn]="searchProductOptions"
                              [preloadFn]="preloadProductOptions"
                              selectClass="form-select form-select-sm"></app-autocomplete-select>
                            <small class="invalid-feedback d-block"
                              *ngIf="line.get('product_id')?.touched && line.get('product_id')?.invalid">Choose a
                              product.</small>
                          </td>
                          <td *ngIf="itemColumnVisible">
                            <app-product-item-picker *ngIf="productUsesIndividualItems(index); else noIndividualItem"
                              formControlName="product_item_id" [productId]="line.get('product_id')?.value"
                              [productVariantId]="productUsesIndividualItems(index) ? null : line.get('product_variant_id')?.value"
                              [locationId]="locationId"
                              (itemSelected)="onItemSelected(index, $event)">
                            </app-product-item-picker>
                            <ng-template #noIndividualItem><span class="text-secondary">—</span></ng-template>
                            <small class="invalid-feedback d-block"
                              *ngIf="line.get('product_item_id')?.touched && line.get('product_item_id')?.invalid">Choose
                              the exact item leaving stock.</small>
                          </td>
                          <td>
                            <app-product-variant-picker formControlName="product_variant_id"
                              [product]="productForLine(index)" [productId]="line.get('product_id')?.value"
                              [required]="requireVariant" [disabled]="isReadOnly || productUsesIndividualItems(index)"
                              triggerClass="form-select form-select-sm"
                              [selectedValueIds]="selectedValueIds(index)"
                              (selectedValueIdsChange)="onLineAttributeSelection(index, $event)"
                              (variantSelected)="variantSelected.emit({ index: index, variant: $event })">
                            </app-product-variant-picker>
                          </td>
                          <td *ngIf="showDescription"><input class="form-control form-control-sm" formControlName="description" [readonly]="isReadOnly" aria-label="Line description"></td>
                          <td>
                            <input class="form-control form-control-sm" type="number" min="0.0001" step="0.0001"
                              formControlName="quantity" [readonly]="isReadOnly || !!line.get('product_item_id')?.value" />
                            <small *ngIf="line.getError('stockAvailability')" class="text-danger d-block" role="status">{{ line.getError('stockAvailability') }}</small>

                          </td>
                          <td *ngIf="showScheduledDate"><input class="form-control form-control-sm" [type]="scheduledDateType" formControlName="scheduled_date" [readonly]="isReadOnly"></td>
                          <td *ngIf="showUom"><select *ngIf="editableUom; else displayUom" class="form-select form-select-sm" formControlName="uom_id"><option value="">Use product unit</option><option *ngFor="let unit of uomOptions" [value]="unit.value">{{ unit.label }}</option></select><ng-template #displayUom>{{ line.get('uom')?.value }}</ng-template></td>
                          <td><app-money-input *ngIf="allowPriceEdit && !isReadOnly; else lockedPrice" formControlName="unit_price"
                              inputClass="form-control form-control-sm"></app-money-input><ng-template #lockedPrice>{{ asCurrency(moneyAmount(line.get('unit_price')?.value)) }}</ng-template></td>
                          <td *ngIf="showDeposit"><app-money-input *ngIf="!isReadOnly; else lockedDeposit" formControlName="deposit_amount" inputClass="form-control form-control-sm"></app-money-input><ng-template #lockedDeposit>{{ asCurrency(moneyAmount(line.get('deposit_amount')?.value)) }}</ng-template></td>
                          <td *ngIf="showDiscount"><input class="form-control form-control-sm" type="number" min="0" max="100" step="0.01"
                              [formControlName]="discountControl" [readonly]="isReadOnly" /></td>
                          <td *ngIf="showTaxes">
                            <app-tax-selector formControlName="tax_ids" [taxes]="taxes" [scope]="mode"
                              [defaultToFirst]="false" [defaultTaxIds]="defaultTaxIds"></app-tax-selector>

                          </td>
                          <td *ngIf="showAccount"><app-autocomplete-select formControlName="account_id" [options]="accountOptions" placeholder="Search accounts" selectClass="form-select form-select-sm"></app-autocomplete-select></td>
                          <td *ngIf="analyticColumnVisible">
                            <app-analytic-distribution-input formControlName="analytic_distribution"
                              [partnerId]="partnerId"
                              [productId]="line.get('product_id')?.value"
                              [defaultDistribution]="productForLine(index)?.default_analytic_distribution ?? null"
                              [amount]="line.get('subtotal')?.value || 0"
                              [transactionDate]="ownerForm.get('document_date')?.value || ownerForm.get('expected_arrival')?.value">
                            </app-analytic-distribution-input>
                          </td>
                          <td class="text-end">
                            <small *ngIf="showTaxes" class="text-secondary">{{ asCurrency(line.get('tax_amount')?.value) }}</small>
                            <small *ngIf="line.getError('taxCalculation')" class="text-danger d-block" role="status">{{ line.getError('taxCalculation') }}</small>
                          </td>
                          <td class="text-end">
                            <div class="fw-semibold">{{ asCurrency(line.get('total')?.value) }}</div>
                          </td>
                          <td class="text-end"><button *ngIf="!isReadOnly"
                              class="btn btn-sm btn-danger line-mutation-action btn-icon" type="button"
                              (click)="removeLine.emit(index)"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="icon icon-tabler icons-tabler-outline icon-tabler-x">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                              </svg></button></td>
                        </ng-container>
                        <ng-template #textLine>
                          <td [attr.colspan]="columnCount - 2">
                            <div class="d-flex align-items-center gap-2">
                              <span class="badge" [class.bg-primary-lt]="lineType(line) === 'section'"
                                [class.bg-secondary-lt]="lineType(line) === 'note'">{{ lineType(line) === 'section' ?
                                'Section' : 'Note' }}</span>
                              <input class="form-control form-control-sm" formControlName="description"
                                [readonly]="isReadOnly"
                                [placeholder]="lineType(line) === 'section' ? 'Section title' : 'Customer-visible note'">
                            </div>
                            <small class="invalid-feedback d-block"
                              *ngIf="line.get('description')?.touched && line.get('description')?.invalid">Enter {{
                              lineType(line) }} text.</small>
                          </td>
                          <td class="text-end"><button *ngIf="!isReadOnly"
                              class="btn btn-sm btn-danger line-mutation-action btn-icon" type="button"
                              (click)="removeLine.emit(index)"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="icon icon-tabler icons-tabler-outline icon-tabler-x">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                              </svg></button></td>
                        </ng-template>
                      </tr>
                      <tr *ngIf="!isReadOnly">
                        <td [attr.colspan]="columnCount" class="py-2">
                          <button class="btn btn-sm me-2" type="button" [disabled]="!locationId" (click)="addLine.emit('product')">Add product</button>
                          <button class="btn btn-sm me-2" type="button" [disabled]="!locationId" (click)="addLine.emit('section')">Add section</button>
                          <button class="btn btn-sm me-2" type="button" [disabled]="!locationId" (click)="addLine.emit('note')">Add note</button>
                          <ng-content select="[lineActions]"></ng-content>
<a class="btn btn-sm me-2" [routerLink]="productCreateRoute" appOpenInNewTab>Create
                            product</a>
                          <a class="btn btn-sm me-2" [routerLink]="['/configuration/accounting-finance/taxes']"
                            appOpenInNewTab>Configure taxes</a>
                        </td>
                      </tr>
                      <tr>
                        <td [attr.colspan]="columnCount - 4"></td>
                        <td colspan="2">Untaxed amount</td>
                        <td class="text-end">{{ asCurrency(untaxedTotal) }}</td>
                        <td></td>
                      </tr>
                      <tr *ngIf="orderDiscountAmount">
                        <td [attr.colspan]="columnCount - 4"></td>
                        <td colspan="2">Order discount</td>
                        <td class="text-end">-{{ asCurrency(orderDiscountAmount) }}</td>
                        <td></td>
                      </tr>
                      <tr *ngIf="shippingAmount || shippingTaxAmount">
                        <td [attr.colspan]="columnCount - 4"></td>
                        <td colspan="2">Shipping</td>
                        <td class="text-end">{{ asCurrency(shippingAmount + shippingTaxAmount) }}</td>
                        <td></td>
                      </tr>
                      <tr *ngIf="showTaxes">
                        <td [attr.colspan]="columnCount - 4"></td>
                        <td colspan="2">Taxes</td>
                        <td class="text-end">{{ asCurrency(taxTotal) }}</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td [attr.colspan]="columnCount - 4"></td>
                        <td colspan="2">Total</td>
                        <td class="text-end">{{ asCurrency(grandTotal) }}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  </fieldset>
                </div>
